import * as React from 'react';
import IReportFeed from './IReportFeed';
import CompaniesPageService from '@services/CompaniesPage.service';
import Loader from '@appComponents/Loader/Loader';

import * as style from './ReportFeedStyle.module.scss'
import * as elements from '@appStyles/_elements.module.scss';

type State = { selected: string; msg: string; sent: boolean; loader: boolean };

export default class ReportFeedForm extends React.Component<IReportFeed, State> {
  state: State = { selected: '1', msg: '', sent: false, loader: false };

  inputChange = (e: React.BaseSyntheticEvent) => {
    this.setState({ [e.target.name]: e.target.value } as Pick<State, keyof State>);
  }

  submit = () => {
    this.setState({ loader: true });

    const data = {
      reason: this.state.selected,
      description: this.state.msg,
    };

    CompaniesPageService.reportPost(this.props.postId, data)
      .then((res) => {
        this.setState({ sent: true, loader: false });
      });
  }

  step1 = () => {
    const { selected } = this.state;

    return (
      <React.Fragment>
        <h3 className={style.headline}>Why are you are reporting this?</h3>
        <div className={[elements.customRadio].join(' ')}>
          <input
            onChange={this.inputChange}
            id="option1"
            type="radio"
            name="selected"
            value="1"
            checked={selected === '1'}
          />
          <label htmlFor="option1">I think it's inappropriate for BnkToTheFuture</label>
        </div>
        <div className={[elements.customRadio].join(' ')}>
          <input
            onChange={this.inputChange}
            id="option2"
            type="radio"
            name="selected"
            value="2"
            checked={selected === '2'}
          />
          <label htmlFor="option2">I think it's spam, a scam, or a fake account</label>
        </div>
        <div className={[elements.customRadio].join(' ')}>
          <input
            onChange={this.inputChange}
            id="option3"
            type="radio"
            name="selected"
            value="3"
            checked={selected === '3'}
          />
          <label htmlFor="option3">I think the topic or language is offensive</label>
        </div>
        <div className={[elements.customRadio].join(' ')}>
          <input
            onChange={this.inputChange}
            id="option4"
            type="radio"
            name="selected"
            value="4"
            checked={selected === '4'}
          />
          <label htmlFor="option4">I think it's something else</label>
        </div>

        {selected === '4' &&
          <textarea
            value={this.state.msg}
            onChange={this.inputChange}
            className={style.message}
            name="msg"
            placeholder="What is it?"
          />
        }

        <button
          onClick={this.submit}
          className={style.submit}
          disabled={selected === '4' && this.state.msg.length < 3}
        >
          Submit
        </button>
      </React.Fragment>
    );
  }

  step2 = () => (
    <React.Fragment>
      <h3 className={style.headline}>Thank you for reporting this</h3>
      <p className={style.success}>
        We appreciate you letting us know. We'll take a look on this comment as soon as possible.
      </p>
    </React.Fragment>
  )

  render() {
    return (
      <div className={style.form}>
        {this.state.loader ? <Loader /> : this.state.sent ? this.step2() : this.step1()}
      </div>
    );
  }
}
